module.exports = __webpack_public_path__ + "static/img/new_year_icon21.dede867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_year_activity/new_year_icon21.png
// module id = 537
// module chunks = 0